import { PropsWithChildren } from 'react'

import { GenericalRecord } from '@eastcoal/common/types/utilities'

import { CrudModalFormContainer } from './Container'
import { CrudModalFormCore } from './Core'
import { CrudModalFormProps } from './interface'
import { CrudModalFormStoreProvider } from './Store'

export const CrudModalForm = <
  FormData extends GenericalRecord,
  DetailData extends GenericalRecord,
  Context
>({
  /* -------------------------------------------------------------------------- */
  /*                      CrudModalFormStoreProvider Props                      */
  /* -------------------------------------------------------------------------- */
  open,
  onOpenChange,

  /* -------------------------------------------------------------------------- */
  /*                          CrudModalFormCore Props                           */
  /* -------------------------------------------------------------------------- */
  name,
  schema,
  grid,
  layout,

  /* ************************************************************************** */
  /*                        CrudModalFormContainer Props                        */
  /* ************************************************************************** */
  children,
  ...restProps
}: PropsWithChildren<CrudModalFormProps<FormData, DetailData, Context>>) => {
  return (
    <CrudModalFormStoreProvider open={open} onOpenChange={onOpenChange}>
      <CrudModalFormContainer {...restProps}>
        <CrudModalFormCore
          grid={grid}
          layout={layout}
          name={name}
          schema={schema}
        />
        {children}
      </CrudModalFormContainer>
    </CrudModalFormStoreProvider>
  )
}
